import styles from "../../../styles/Components/mini-app/mini-portfolio/ExchangeAccountAssets.module.css";
import useExchangePortfolioInfo from "../../../hooks/exchange/useExchangePortfolioInfo";
import { Skeleton } from "antd";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { formatAmount, formatPrice } from "../../../utility/helper";

function ExchangeAccountAssets() {
  const { portfolioLoading, portfolioData } = useExchangePortfolioInfo();

  const usdtData = portfolioData?.filter((asset) => asset.assetName === "USDT");
  const otherAssets = portfolioData?.filter(
    (asset) => asset.assetName !== "USDT",
  );
  const sortedAssets = otherAssets?.sort(
    (a, b) => Number(b?.availableBalanceUSD) - Number(a?.availableBalanceUSD),
  );

  const assets = [...usdtData, ...sortedAssets];

  return (
    <div className={styles.container}>
      <h5>Assets</h5>
      {portfolioLoading ? (
        Array.from({ length: 5 }).map((_, i) => (
          <div className={styles.loading} key={i}>
            <Skeleton.Avatar active size="large" />
            <div className={styles.rows}>
              <Skeleton.Node active />
              <Skeleton.Node active />
            </div>
          </div>
        ))
      ) : portfolioData?.length === 0 ? (
        <div className={styles.emptyBox}></div>
      ) : (
        <ul className={styles.assetsList}>
          {assets?.map((asset) => (
            <li key={asset?.assetName} className={styles.assetItem}>
              <div className={styles.assetName}>
                <LazyLoadImage
                  src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/symbol_icons/${asset?.assetName?.replace("/USDT", "")}.png`}
                  alt={asset?.assetName}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/placeholders/asset-logo.svg";
                  }}
                  width="25px"
                  height="25px"
                  effect="blur"
                  style={{ borderRadius: "100%" }}
                />
                <span>{asset?.assetName}</span>
              </div>

              <div className={styles.assetBalance}>
                {asset?.assetName !== "USDT" && (
                  <span>${formatPrice(asset?.availableBalanceUSD)}</span>
                )}
                <span
                  style={
                    asset?.assetName === "USDT" ? { fontSize: "14px" } : {}
                  }
                >
                  {formatPrice(asset?.availableBalance)}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ExchangeAccountAssets;
